import { VotingRadioButtonList } from "./VotingRadioButtonList";

export default VotingRadioButtonList;